import { chakra, ChakraProps } from '@chakra-ui/react'

import { chakraColorToCSSVariable } from 'src/lib/utils'
import { BrandColor } from 'src/types'

import InsideCustomIcon from '../InsideCustomIcon'

const AirtableIcon = ({
  brandColor = 'brand.200',
  ...props
}: {
  brandColor?: BrandColor
} & ChakraProps) => {
  return (
    <InsideCustomIcon brandColor={brandColor}>
      <chakra.svg
        width="21"
        height="18"
        viewBox="0 0 21 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M10.493 2.44347e-06C10.1132 2.44347e-06 9.73174 0.0736406 9.37299 0.220061L1.55662 3.38307C1.1165 3.56117 1.12787 4.16055 1.56712 4.33866L9.42637 7.38522C10.1149 7.65836 10.8851 7.65836 11.5736 7.38522L19.4329 4.33866C19.873 4.17083 19.873 3.56117 19.4434 3.38307L11.606 0.220061C11.2538 0.0743469 10.8753 -0.000492958 10.493 2.44347e-06ZM20.475 5.21461C20.4083 5.21503 20.3423 5.22812 20.2807 5.25314L11.5202 8.57285C11.4222 8.61214 11.3383 8.67899 11.2791 8.76495C11.2199 8.85092 11.1881 8.95212 11.1877 9.05577V16.673C11.1886 16.7564 11.2101 16.8384 11.2506 16.9118C11.291 16.9852 11.3491 17.0479 11.4198 17.0944C11.4905 17.1409 11.5717 17.1699 11.6565 17.1789C11.7412 17.1878 11.8269 17.1764 11.9061 17.1457L20.6675 13.8148C20.7657 13.7791 20.8503 13.7147 20.9098 13.6303C20.9693 13.5459 21.0008 13.4456 21 13.3431V5.72579C20.9991 5.59013 20.9433 5.46033 20.845 5.36472C20.7466 5.26912 20.6136 5.21546 20.475 5.21546V5.21461ZM0.5915 5.248C0.513811 5.2453 0.436393 5.25836 0.364112 5.28636C0.291832 5.31436 0.226253 5.35669 0.1715 5.41069C0.0752499 5.50573 0 5.62047 0 5.75747V12.9115C0 13.29 0.450625 13.5426 0.794499 13.3739L6.28075 10.8L6.54937 10.6741L9.14724 9.44452C9.55499 9.25614 9.52349 8.66703 9.09387 8.50948L0.772624 5.28482C0.715182 5.26131 0.653748 5.24853 0.5915 5.24714V5.248Z"
          fill={chakraColorToCSSVariable(brandColor)}
        />
      </chakra.svg>
    </InsideCustomIcon>
  )
}

export default AirtableIcon
